const TITLE = 'White Lotus Theme Button — Tap to Play “Aloha!”'
const DESCRIPTION =
  'One button. Tap it and The White Lotus theme song (“Aloha!” by Cristóbal Tapia de Veer) starts playing. Triple-tap to stop. A tiny, silly fan-made toy.'
const OG_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/c5cb1a36-1265-41d9-bc4c-054429fef94d.jpg'
const OG_IMAGE_ALT = 'A cream “Aloha!” button on dark tropical wallpaper with hibiscus flowers and monkeys'

type MetaTag = { attr: 'name' | 'property'; key: string; content: string }

const metaTags: MetaTag[] = [
  { attr: 'name', key: 'description', content: DESCRIPTION },
  { attr: 'name', key: 'keywords', content: 'White Lotus theme song, Aloha, White Lotus intro, Cristobal Tapia de Veer, HBO, theme button' },
  { attr: 'name', key: 'robots', content: 'index, follow' },
  { attr: 'name', key: 'theme-color', content: '#16352A' },
  { attr: 'property', key: 'og:type', content: 'website' },
  { attr: 'property', key: 'og:site_name', content: 'White Lotus Theme Button' },
  { attr: 'property', key: 'og:title', content: TITLE },
  { attr: 'property', key: 'og:description', content: DESCRIPTION },
  { attr: 'property', key: 'og:image', content: OG_IMAGE },
  { attr: 'property', key: 'og:image:alt', content: OG_IMAGE_ALT },
  { attr: 'property', key: 'og:image:width', content: '1376' },
  { attr: 'property', key: 'og:image:height', content: '768' },
  { attr: 'name', key: 'twitter:card', content: 'summary_large_image' },
  { attr: 'name', key: 'twitter:title', content: TITLE },
  { attr: 'name', key: 'twitter:description', content: DESCRIPTION },
  { attr: 'name', key: 'twitter:image', content: OG_IMAGE },
  { attr: 'name', key: 'twitter:image:alt', content: OG_IMAGE_ALT },
]

function upsertMeta({ attr, key, content }: MetaTag) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.rel = rel
    document.head.appendChild(el)
  }
  el.href = href
}

export function applySeoTags() {
  const url = `${window.location.origin}/`
  document.title = TITLE
  document.documentElement.lang = 'en'
  metaTags.forEach(upsertMeta)
  upsertMeta({ attr: 'property', key: 'og:url', content: url })
  upsertLink('canonical', url)

  const schemaId = 'seo-jsonld'
  if (!document.getElementById(schemaId)) {
    const script = document.createElement('script')
    script.id = schemaId
    script.type = 'application/ld+json'
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebApplication',
      name: 'White Lotus Theme Button',
      description: DESCRIPTION,
      url,
      image: OG_IMAGE,
      applicationCategory: 'EntertainmentApplication',
      operatingSystem: 'Any',
      offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
    })
    document.head.appendChild(script)
  }
}
